import { createAuth0Client } from "@auth0/auth0-spa-js";

let auth0ClientPromise = null;

/**
 * Returns a singleton Auth0 client instance.
 * The client is lazily initialized on first call.
 */
export function getAuth0Client() {
  if (!auth0ClientPromise) {
    auth0ClientPromise = createAuth0Client({
      domain: process.env.VUE_APP_AUTH0_DOMAIN,
      clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
      authorizationParams: {
        audience: process.env.VUE_APP_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin + "/login",
      },
    });
  }
  return auth0ClientPromise;
}

/**
 * Redirect the user to the Auth0 Universal Login page.
 */
export async function auth0Login() {
  const client = await getAuth0Client();
  await client.loginWithRedirect();
}

/**
 * Handle the Auth0 redirect callback (when the user comes back with ?code=...&state=...).
 */
export async function auth0HandleCallback() {
  const client = await getAuth0Client();
  await client.handleRedirectCallback();
}

/**
 * Get the Auth0 access token silently (for the configured audience).
 */
export async function auth0GetToken() {
  const client = await getAuth0Client();
  return await client.getTokenSilently({
    authorizationParams: {
      audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    },
  });
}

/**
 * Log out from Auth0 and redirect to the app origin.
 */
export async function auth0Logout() {
  const client = await getAuth0Client();
  await client.logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
}
